export const generateId = (numLength: any) => {
  let numberGeneration = '';
  let traceid ='';
  let characters = 'TRC'
  let numbers = '0123456789';
  let numbersLength = numbers.length;
 
  for (let i = 0; i < numLength; i++) {
      numberGeneration += numbers.charAt(Math.floor(Math.random() * numbersLength));
  }
  traceid=characters+numberGeneration;
  return traceid;
}